import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/Card/Card';
import { Input } from '@/components/ui/Input/Input';
import { Button } from '@/components/ui/Button/Button';
import { Spinner } from '@/components/ui/Spinner/Spinner';
import { Avatar } from '@/components/ui/Avatar/Avatar';
import { PageHeader } from '@/components/ui/PageHeader/PageHeader';
import { PageContainer } from '@/components/ui/PageContainer';
import { useNotificationStore } from '@/stores/notificationStore';
import { useAccountProfile, useUpdateProfileMutation } from '@/hooks/queries';

export function ProfilePage() {
  const { data: profile, isLoading: loading } = useAccountProfile();
  const updateProfileMutation = useUpdateProfileMutation();
  const [fullName, setFullName] = React.useState('');

  // Sync fullName state with profile data
  React.useEffect(() => {
    if (profile) {
      setFullName(profile.fullName || '');
    }
  }, [profile]);

  const handleSave = async () => {
    try {
      await updateProfileMutation.mutateAsync({ fullName });
      try { useNotificationStore.getState().success('Profile updated'); } catch {}
    } catch (e) {
      try { useNotificationStore.getState().error('Failed to update profile'); } catch {}
    }
  };

  if (loading) return (<div className="flex items-center justify-center h-40"><Spinner /></div>);

  return (
    <PageContainer>
      <PageHeader 
        title="Profile" 
        description="Manage your personal information and preferences" 
      />

      <div className="space-y-6">
        {/* Content */}
      <Card>
        <CardHeader>
          <CardTitle>Personal Information</CardTitle>
          <CardDescription>Update your name. Email is managed under Security.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center gap-4">
            <Avatar size="md" initials={(profile?.fullName || profile?.email || 'U').charAt(0).toUpperCase()} name={profile?.fullName || profile?.email || 'User'} />
            <div className="text-sm text-muted-foreground">Avatar uploads coming soon</div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Full name</label>
            <Input value={fullName} onChange={e => setFullName(e.target.value)} placeholder="Your full name" />
          </div>
          
        </CardContent>
        <CardFooter>
          <Button onClick={handleSave} disabled={updateProfileMutation.isPending} loading={updateProfileMutation.isPending}>Save changes</Button>
        </CardFooter>
      </Card>
      </div>
    </PageContainer>
  );
}


